import { useMemo } from 'react';

import useHurdlrPlaidItems from '../useHurdlrPlaidItems';
import { HurdlrPlaidItemsData, HurdlrPlaidItemsParams } from '../useHurdlrPlaidItems/useHurdlrPlaidItems.interface';

import { useAccountingOnboardingProgress } from 'services/bookkeeping/queries/useAccountingOnboardingProgress';

interface StepAwarePlaidItemsParams extends HurdlrPlaidItemsParams {
    step?: string;
}

interface StepAwarePlaidItemsData {
    accounts: HurdlrPlaidItemsData;
    stepContext?: {
        step: string;
        isStep1Completed: boolean;
    };
}

// Query key creator function (no longer needed but keeping for potential future use)
// const createUseStepAwarePlaidItemsKey = (params?: StepAwarePlaidItemsParams) => ['step-aware-plaid-items', params];

const useStepAwarePlaidItems = (params?: StepAwarePlaidItemsParams) => {
    const { data: onboardingProgress } = useAccountingOnboardingProgress();

    // Use the base Hurdlr Plaid items query
    const hurdlrQuery = useHurdlrPlaidItems(params);

    // ✅ FIX: Transform data directly without useQuery to prevent flickering
    const processedData: StepAwarePlaidItemsData | undefined = useMemo(() => {
        if (!hurdlrQuery.data) {
            return undefined;
        }

        return {
            accounts: hurdlrQuery.data,
            stepContext: {
                step: params?.step || 'bank_connection',
                // The filtering logic is handled by each step component
                // Step 1: Shows all connected accounts
                // Step 2: Filters out accounts from step 1 data
                isStep1Completed: onboardingProgress?.bank_connection_status === 'completed',
            },
        };
    }, [hurdlrQuery.data, params?.step, onboardingProgress?.bank_connection_status]);

    // ✅ Return the base query with processed data instead of a new useQuery
    return {
        data: processedData,
        isLoading: hurdlrQuery.isLoading,
        error: hurdlrQuery.error,
        refetch: hurdlrQuery.refetch,
        isError: hurdlrQuery.isError,
        isSuccess: hurdlrQuery.isSuccess,
        isFetching: hurdlrQuery.isFetching,
    };
};

export default useStepAwarePlaidItems;
